var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6A6A6A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 11c-.2 0-.3 0-.5-.1L0 6.7V15c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V6.7l-7.5 4.2c-.2.1-.3.1-.5.1z",
    transform: "translate(-89 -858) translate(89 858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.9l6-3.4V1c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v4.5l6 3.4z",
    transform: "translate(-89 -858) translate(89 858)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.0621b378b3573239df0bbca6f62ec763.svg";
export { ForwardRef as ReactComponent };